import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div
      *ngIf="isOpen"
      class="fixed inset-0 z-50 overflow-y-auto"
      (click)="closeOnBackdrop && close()"
    >
      <div class="flex min-h-screen items-center justify-center p-4">
        <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity"></div>

        <div
          class="relative bg-white rounded-lg shadow-xl max-w-{{size}} w-full z-50"
          (click)="$event.stopPropagation()"
        >
          <div class="flex items-center justify-between p-4 border-b">
            <h3 class="text-lg font-semibold text-gray-900">{{ title }}</h3>
            <button
              type="button"
              (click)="close()"
              class="text-gray-400 hover:text-gray-600"
            >
              <app-icon name="x" class="w-6 h-6" />
            </button>
          </div>

          <div class="p-6">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  `
})
export class ModalComponent {
  @Input() title = '';
  @Input() isOpen = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'lg';
  @Input() closeOnBackdrop = true;
  @Output() closeEvent = new EventEmitter<void>();

  close(): void {
    this.isOpen = false;
    this.closeEvent.emit();
  }

  open(): void {
    this.isOpen = true;
  }
}
